import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { AbandonedMine } from '@shared/models/records/abandoned-mine.model';
import { environment } from '@environments/environment';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-abandoned-mine-result-card',
  templateUrl: './abandoned-mine-result-card.component.html',
  styleUrls: ['./abandoned-mine-result-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AbandonedMineResultCardComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() record: any;
    @Input() searchTerm: string;
    searchTerms: string;
    isSingleClick: Boolean = true;     

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.record = new AbandonedMine(this.record._source);
        this.searchTerms = this.searchTerm;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    get abandoned_mine_identifier() {
        return this.record.abandoned_mine_identifier;
    }

    get official_name(): string {
        return this.record.official_name;
    }

    get primary_commodity() {
        return this.record.primary_commodity;
    }

    get mndm_township_area_name(): string {
        return this.record.mndm_township_area_name;
    }

    openInSameTab() {
        this.isSingleClick = true;
        setTimeout(()=>{
            if(this.isSingleClick){
                this.router.navigate(['/abandoned-mine', this.abandoned_mine_identifier], { state: { data: this.record, searchTerms: this.searchTerms} });
            }
        }, 250)
    }

    openInNewTab() {
        this.isSingleClick = false;
        var target = environment.application_url + "persistent-linking?" + DatabaseIndexNameType.abandonedMines + "=" + this.abandoned_mine_identifier;
        this.router.navigate([], { state: { data: this.record, searchTerms: this.searchTerms} }).then(() => {  window.open(target, '_blank'); });
     }
}
